import { Box } from '@mui/material';
import Image from 'next/image';

import wellfareImage from '../../../public/assets/images/AdobeStock_286053032.jpeg';

import type { FC } from 'react';

export const ServiceHero: FC = () => (
  <Box
    width="100%"
    height={350}
    position="relative"
  >
    <Image
      src={wellfareImage}
      sizes="(max-width: 1536px) 100vw, 1250px"
      alt="Beraturngsgespräch"
      fill
      priority
      style={{
        objectFit: 'cover',
      }}
    />
    <Box
      width="100%"
      height="100%"
      position="absolute"
      sx={{
        pointerEvent: 'none',
        background:
          'linear-gradient(180deg, rgba(255, 255, 255, 0) 40%, #FFF 100%), rgba(255, 255, 255, 0)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    />
  </Box>
);
